import { Feature } from '@/queries/products/types';

import { TourGateState } from '../../types';

/**
 * The entitlement that unlocks the TZ+ tour.
 *
 * Distinct from the TOUR id (`tzplus`, see ./ids.ts): the tour id is a persisted key in redux and
 * in `user.tours` on the server and can never change, while this names a product feature whose
 * final spelling is still open.
 */
export const TZ_PLUS_FEATURE: Feature = 'guidedExperience:tzplus';

const isActive = (until: string | undefined): boolean => Boolean(until && Date.parse(until) > Date.now());

/**
 * The gate predicate, pure over `TourGateState` because `isEligible` is not a component and cannot
 * call a hook. `useHasTzPlusFeature` is the React twin; both read the same constant so they cannot
 * disagree about who is eligible. Deliberately free of any `@/redux/selectors` import, so the
 * registry does not drag the selectors module into the tour tests.
 */
export const hasTzPlusFeature = (gate: TourGateState): boolean => isActive(gate.featuresUntil?.[TZ_PLUS_FEATURE]);
